const SET_DANH_SACH_NGUOI_DUNG_THEO_DANH_SACH_DON_VI = (
  state,
  danhSachNguoiDungTheoDanhSachDonVi
) => {
  state.danhSachNguoiDungTheoDanhSachDonVi = danhSachNguoiDungTheoDanhSachDonVi;
};

const SET_CHI_TIET_NGUOI_DUNG = (state, chiTietNguoiDung) => {
  state.chiTietNguoiDung = chiTietNguoiDung;
};

const SET_NGUOI_DUNG_GOM_QUYEN = (state, nguoiDungGomQuyen) => {
  state.nguoiDungGomQuyen = nguoiDungGomQuyen;
};

const SET_DANH_SACH_VAI_TRO_THEO_NGUOI_DUNG = (
  state,
  danhSachVaiTroTheoNguoiDung
) => {
  state.danhSachVaiTroTheoNguoiDung = danhSachVaiTroTheoNguoiDung;
};

const SET_DANH_SACH_GROUP_THEO_NGUOI_DUNG = (
  state,
  danhSachGroupTheoNguoiDung
) => {
  state.danhSachGroupTheoNguoiDung = danhSachGroupTheoNguoiDung;
};

const SET_DANH_SACH_VAI_TRO_KHONG_THUOC_NGUOI_DUNG = (
  state,
  danhSachVaiTroKhongThuocNguoiDung
) => {
  state.danhSachVaiTroKhongThuocNguoiDung = danhSachVaiTroKhongThuocNguoiDung;
};

const SET_DANH_SACH_GROUP_KHONG_THUOC_NGUOI_DUNG = (
  state,
  danhSachGroupKhongThuocNguoiDung
) => {
  state.danhSachGroupKhongThuocNguoiDung = danhSachGroupKhongThuocNguoiDung;
};

const SET_DANH_SACH_QUYEN_THEO_NGUOI_DUNG = (
  state,
  danhSachQuyenTheoNguoiDung
) => {
  state.danhSachQuyenTheoNguoiDung = danhSachQuyenTheoNguoiDung;
};

const SET_DANH_SACH_QUYEN_KHONG_THUOC_NGUOI_DUNG = (
  state,
  danhSachQuyenKhongThuocNguoiDung
) => {
  state.danhSachQuyenKhongThuocNguoiDung = danhSachQuyenKhongThuocNguoiDung;
};

const SET_DANH_SACH_NGUOI_DUNG_THEO_GROUP = (
  state,
  danhSachNguoiDungTheoGroup
) => {
  state.danhSachNguoiDungTheoGroup = danhSachNguoiDungTheoGroup;
};

const SET_DANH_SACH_NGUOI_DUNG_KHONG_THUOC_VAI_TRO = (
  state,
  danhSachNguoiDungKhongThuocVaiTro
) => {
  state.danhSachNguoiDungKhongThuocVaiTro = danhSachNguoiDungKhongThuocVaiTro;
};

const SET_DANH_SACH_NGUOI_DUNG_THEO_VAI_TRO = (
  state,
  danhSachNguoiDungTheoVaiTro
) => {
  state.danhSachNguoiDungTheoVaiTro = danhSachNguoiDungTheoVaiTro;
};

const SET_DANH_SACH_CAN_BO_VAO_NGUOI_DUNG = (
  state,
  danhSachCanBoLayVaoNguoiDung
) => {
  state.danhSachCanBoLayVaoNguoiDung = danhSachCanBoLayVaoNguoiDung;
};

export default {
  SET_DANH_SACH_NGUOI_DUNG_THEO_DANH_SACH_DON_VI,
  SET_DANH_SACH_VAI_TRO_THEO_NGUOI_DUNG,
  SET_DANH_SACH_VAI_TRO_KHONG_THUOC_NGUOI_DUNG,
  SET_DANH_SACH_QUYEN_THEO_NGUOI_DUNG,
  SET_DANH_SACH_QUYEN_KHONG_THUOC_NGUOI_DUNG,
  SET_CHI_TIET_NGUOI_DUNG,
  SET_NGUOI_DUNG_GOM_QUYEN,
  SET_DANH_SACH_NGUOI_DUNG_THEO_GROUP,
  SET_DANH_SACH_NGUOI_DUNG_KHONG_THUOC_VAI_TRO,
  SET_DANH_SACH_NGUOI_DUNG_THEO_VAI_TRO,
  SET_DANH_SACH_CAN_BO_VAO_NGUOI_DUNG,
  SET_DANH_SACH_GROUP_THEO_NGUOI_DUNG,
  SET_DANH_SACH_GROUP_KHONG_THUOC_NGUOI_DUNG,

};
